import React from 'react';
import { TbUsers } from 'react-icons/tb';
import { lazyPage } from '../lazyPage';

const DealerChats = lazyPage(() => import(/* webpackChunkName: "m-dealers" */ './pages/DealerChatsPage'));

/**
 * Dealer Chats (Dealer_mgmt) — oversight of dealers' WhatsApp conversations.
 * Shown to users granted `Dealer_mgmt`; the backend enforces the same permission
 * and org-scopes the data.
 */
const dealersManifest = {
    id: 'dealer-chats',
    featureName: 'Dealer_mgmt',
    permission: 'view',
    routes: [{ path: '/dealer-chats', element: <DealerChats /> }],
    sidebarItems: [{ text: 'Dealer Chats', icon: <TbUsers />, link: '/dealer-chats' }],
};

export default dealersManifest;
